export interface WoundAcknowledgement {
  isMainExamination: boolean;
  subExaminationCount: number;
}

/**
 * Derives wound cascade acknowledgement data from an examination object.
 * Returns undefined for non-wound examinations or when there are no sub-examinations to disclose.
 */
export function getWoundAcknowledgement(examination: {
  is_main_examination?: boolean | number;
  main_examination_id?: number | null;
  sub_examinations_count?: number;
}): WoundAcknowledgement | undefined {
  if (!examination) return undefined;

  const isMain = !!examination.is_main_examination;
  const isSub = examination.main_examination_id != null;
  const subCount = examination.sub_examinations_count ?? 0;

  if (!isMain && !isSub) return undefined;
  if (isMain && subCount === 0) return undefined;

  return {
    isMainExamination: isMain,
    subExaminationCount: subCount,
  };
}
